module.exports = __webpack_public_path__ + "static/media/why-soil-is-dissappearing-from-our-farms.bf7dc440.jpg";